const STORAGE_VERSION = 1;

export const ADVANCED_TOUR_START_EVENT = "advanced-welcome-tour:start";

function restaurantScope() {
  return localStorage.getItem("restaurantId") || "default";
}

function scopedKey(suffix) {
  return `advancedWelcomeTour:${STORAGE_VERSION}:${suffix}:${restaurantScope()}`;
}

export function isAdvancedWelcomeTourComplete() {
  return localStorage.getItem(scopedKey("complete")) === "true";
}

export function markAdvancedWelcomeTourComplete() {
  localStorage.setItem(scopedKey("complete"), "true");
}

export function clearAdvancedWelcomeTourComplete() {
  localStorage.removeItem(scopedKey("complete"));
}

export function isAdvancedWelcomeTourSessionDismissed() {
  return sessionStorage.getItem(scopedKey("sessionDismiss")) === "true";
}

export function dismissAdvancedWelcomeTourForSession() {
  sessionStorage.setItem(scopedKey("sessionDismiss"), "true");
}

export function clearAdvancedWelcomeTourSessionDismiss() {
  sessionStorage.removeItem(scopedKey("sessionDismiss"));
}

export function wasAdvancedWelcomeTourAutoPrompted() {
  return sessionStorage.getItem(scopedKey("autoPrompted")) === "true";
}

export function markAdvancedWelcomeTourAutoPrompted() {
  sessionStorage.setItem(scopedKey("autoPrompted"), "true");
}

export function startAdvancedWelcomeTour() {
  clearAdvancedWelcomeTourSessionDismiss();
  window.dispatchEvent(new CustomEvent(ADVANCED_TOUR_START_EVENT));
}

export function clearAdvancedWelcomeTourState() {
  clearAdvancedWelcomeTourComplete();
  clearAdvancedWelcomeTourSessionDismiss();
  sessionStorage.removeItem(scopedKey("autoPrompted"));
}

/** True when the account looks newly created and has not finished the advanced walkthrough. */
export function shouldOfferAdvancedWelcomeTour({ restaurant, menus } = {}) {
  if (isAdvancedWelcomeTourComplete()) return false;
  if (isAdvancedWelcomeTourSessionDismissed()) return false;
  if (!restaurant) return false;

  const menuCount = Array.isArray(menus) ? menus.length : 0;
  const profileIncomplete =
    !restaurant.nameRes?.trim() || !restaurant.country?.trim() || !restaurant.logo;

  let isRecentlyCreated = false;
  if (restaurant.createdAt) {
    const createdMs = new Date(restaurant.createdAt).getTime();
    if (!Number.isNaN(createdMs)) {
      const daysSince = (Date.now() - createdMs) / (1000 * 60 * 60 * 24);
      isRecentlyCreated = daysSince <= 21;
    }
  }

  return isRecentlyCreated || (profileIncomplete && menuCount === 0);
}
